<template>
    <div class="wrapper-box">
        <web-header></web-header>
        <web-slide :data="data"></web-slide>
        <web-products :products="products"></web-products>
        <web-parallax></web-parallax>
        <web-footer></web-footer>
        <web-arrow-up></web-arrow-up>
    </div>
</template>
<script>
import header from "@/components/header";
import slide from "@/components/slide";
import content from "@/components/content";
import parallax from "@/components/parallax";
import footer from "@/components/footer";
import products from "@/components/categories/products";
import arrowUp from "@/components/arrowUp.vue";

import bg from "../../assets/images/categories/banners/titulo_mixaves.jpg";
import bgMob from "../../assets/images/categories/banners/titulo_mixaves_mobile.jpg";

import img1 from "../../assets/images/products/mixaves_periquitos.jpg";
import img2 from "../../assets/images/products/mixaves_silvestres.jpg";
import img3 from "../../assets/images/products/mixaves_canarios.jpg";
import img4 from "../../assets/images/products/mixaves_loros.jpg";
import img5 from "../../assets/images/products/mixaves_alpiste.jpg";
import img6 from "../../assets/images/products/mixaves_girasol.jpg";
import img7 from "../../assets/images/products/mixaves_mijo.jpg";

export default {
  name: "naturalMixAves",
  data() {
    return {
      data: [
        {
          html:
            " <h1>NATURAL MIX - AVES</h1><p>Alimento a base de materias primas de primera calidad que constituye una dieta balanceada a la medida de sus aves</p>",
          style:
            "background:url(" +
            this.getBg() +
            ") no-repeat; background-size:cover;    background-position: center; height:300px; "
        }
      ],
      products: [
        {
          image: img1,
          title: "MIX PERIQUITOS",
          description: `El Mix para Periquitos de Nelsoni Ranch Especialmente formulado para pequeños psitácidos como periquitos australianos, variedades de agapornis, entre otros.<br>
Ingredientes: mijo rojo, mijo verde, mijo amarillo, alpiste, girasol rayado chico, avena pelada, cártamo, con vitaminas.`,
          extraData: "Presentación 750 gr. y 10 kilos."
        },
        {
          image: img2,
          title: "MIX SILVESTRES",
          description: `El Mix para pájaros Silvestres de Nelsoni Ranch Especialmente formulado para pájaros silvestres como diamantes de Gould, Mandarin, jilgueros entre otros.<br>
Ingredientes: mijo rojo, mijo verde, mijo amarillo, colza (canola), alpiste, con vitaminas.
`,
          extraData: "Presentación 750 gr. y 10 kilos."
        },
        {
          image: img3,
          title: "MIX CANARIOS",
          description: `El Mix para Canarios de Nelsoni Ranch provee una optima nutrición con todas las vitaminas y nutrientes que las mejores semillas pueden dar, manteniendo a su canario vital y feliz. <br>
Ingredientes: alpiste, colza (canola), avena pelada, lino, con vitaminas.
`,
          extraData: "Presentación 750 gr. y 10 kilos."
        },
        {
          image: img4,
          title: "MIX LOROS",
          description: `
El Mix para loros de Nelsoni Ranch Especialmente formulado para psitácidos de porte mediano a grande como guacamayos, loros amazónicos,  entre otros.<br>
Se recomienda suplementar su alimentación con frutas de estación.<br>
Ingredientes: girasol confitero grande, semillas de zapallo, maní con cáscara, cártamo, trigo sarraceno, trigo candeal, maíz, avena, cebada.
`,
          extraData: "Presentación 600 gr. y 10 kilos."
        },
        {
          image: img5,
          title: "ALPISTE CON VITAMINAS",
          description: `Seleccionamos  las semillas de la mejor calidad, libres de polvo y cascarillas. Nuestro Alpiste viene con vitaminas`,
          extraData: "Presentación 750 gr. y 10 kilos."
        },
        {
          image: img6,
          title: "GIRASOL CONFITERO",
          description: `Semillas de girasol confitero de la mejor calidad seleccionadas para una excelente nutrición. <br>Libres de polvo y cascarillas con el más grande y mejor tamaño que su mascota prefiere.`,
          extraData: "Presentación 400 gr. y 10 kilos."
        },
        {
          image: img7,
          title: "MIJO CON VITAMINAS",
          description: `Semillas de la mejor calidad seleccionadas para una excelente nutrición.<br>
Libres de polvo y cascarillas. con vitaminas`,
          extraData: "Presentación 750 gr. y 10 kilos"
        }
      ]
    };
  },
  components: {
    webHeader: header,
    webSlide: slide,
    webContent: content,
    webParallax: parallax,
    webFooter: footer,
    webProducts: products,
    webArrowUp: arrowUp
  },
  methods: {
    detectmob() {
      if (window.screen.availWidth <= 800) {
        return true;
      } else {
        return false;
      }
    },
    getBg() {
      if (this.detectmob()) {
        return bgMob;
      }
      return bg;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/categories/naturalMixAves.vue